const install = function(Vue) {
  //过滤器
  Vue.filter("upperCase", function(value) {
    if (!value) return "";
    return value.toUpperCase();
  });
};

export default { install };
